/* eslint-disable @typescript-eslint/naming-convention */
export enum CMUProfile {
  CMU_4 = "CMU_4",
  CMU_6 = "CMU_6",
  CMU_8 = "CMU_8",
  CMU_10 = "CMU_10",
  CMU_12 = "CMU_12",
  CMU_8x8x24 = "CMU_8x8x24",
}
/* eslint-enable @typescript-eslint/naming-convention */

const CMU_NOMINAL_HEIGHT = 7 + 5 / 8;
const CMU_NOMINAL_LENGTH = 15 + 5 / 8;

export const CMUProfileToNominalWidth: { [key in CMUProfile]: number } = {
  [CMUProfile.CMU_4]: 3 + 5 / 8,
  [CMUProfile.CMU_6]: 5 + 5 / 8,
  [CMUProfile.CMU_8]: 7 + 5 / 8,
  [CMUProfile.CMU_10]: 9 + 5 / 8,
  [CMUProfile.CMU_12]: 11 + 5 / 8,
  [CMUProfile.CMU_8x8x24]: 7 + 5 / 8,
};

export interface CMUNominalSize {
  readonly width: number;
  readonly height: number;
  readonly length: number;
}

export const CMUProfileToNominalSize: { [key in CMUProfile]: CMUNominalSize } = {
  [CMUProfile.CMU_4]: {
    width: CMUProfileToNominalWidth[CMUProfile.CMU_4],
    height: CMU_NOMINAL_HEIGHT,
    length: CMU_NOMINAL_LENGTH,
  },
  [CMUProfile.CMU_6]: {
    width: CMUProfileToNominalWidth[CMUProfile.CMU_6],
    height: CMU_NOMINAL_HEIGHT,
    length: CMU_NOMINAL_LENGTH,
  },
  [CMUProfile.CMU_8]: {
    width: CMUProfileToNominalWidth[CMUProfile.CMU_8],
    height: CMU_NOMINAL_HEIGHT,
    length: CMU_NOMINAL_LENGTH,
  },
  [CMUProfile.CMU_10]: {
    width: CMUProfileToNominalWidth[CMUProfile.CMU_10],
    height: CMU_NOMINAL_HEIGHT,
    length: CMU_NOMINAL_LENGTH,
  },
  [CMUProfile.CMU_12]: {
    width: CMUProfileToNominalWidth[CMUProfile.CMU_12],
    height: CMU_NOMINAL_HEIGHT,
    length: CMU_NOMINAL_LENGTH,
  },
  [CMUProfile.CMU_8x8x24]: {
    width: CMUProfileToNominalWidth[CMUProfile.CMU_8x8x24],
    height: CMU_NOMINAL_HEIGHT,
    length: 23 + 5 / 8, // special case for 8x8x24 CMU
  },
};
